export default function(major, minor, arr) {
  return arr.map((el, i) => ({
    id: `${minor}_${i + 1}`,
    alt: el,
    src: `../../img/photography/brands/${major}/${minor}/n/${i + 1}.jpg`,
    loading: `../../img/photography/brands/${major}/${minor}/l/${i + 1}.jpg`
  }));
}
